import {
    Component, Input
} from '@angular/core';

import Broadcaster from '../../services/broadcaster.service';
import IBroadcastMessage from '../../interfaces/IBroadcastMessage';
import EVENTS from '../../enums/events.enum';


@Component({
    selector: 'loader',
    template: require('./loader.html'),
    styles: [String(require('./loader.styl'))]
})

export class LoaderComponent {

    private isEnabled: boolean = false;
    private subscribtion;
    @Input() config = {
        topOffset: '52px'
    }

    constructor(Broadcaster: Broadcaster) {
        this.subscribtion = Broadcaster.subscribe((BroadcastMessage: IBroadcastMessage) => {
            if (BroadcastMessage.event === EVENTS.LOADER) {
                this.isEnabled = BroadcastMessage.message.isEnabled;
            }
        })
    }

    ngOnDestroy() {
        this.subscribtion.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/components/loader/loader.component.ts